import DownloadIcon from '@mui/icons-material/Download';
import { ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton, Tooltip, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface ExpandableSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  onExport?: () => void;
}

export const ExpandableSection = ({ title, expanded, onToggle, children, onExport }: ExpandableSectionProps) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          mb: 2,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
          borderRadius: 1,
          p: 1,
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }} onClick={onToggle}>
          <IconButton
            size='small'
            sx={{
              transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'transform 0.3s',
            }}>
            <ExpandMore />
          </IconButton>
          <Typography variant='h6'>{title}</Typography>
        </Box>
        {onExport && (
          <Tooltip title='Export section metrics'>
            <IconButton
              size='small'
              onClick={(e) => {
                e.stopPropagation();
                onExport();
              }}
              sx={{ color: '#1a667a' }}>
              <DownloadIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Collapse in={expanded}>{children}</Collapse>
    </Box>
  );
};
